/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_ACTIVITIES_LIST_RECORDS_META_DATA,
  LOAD_ACTIVITIES_LIST,
  LOAD_STATE_ACTIVITIES_LIST,
  LOAD_CITY_ACTIVITIES_LIST,
  LOAD_AREA_ACTIVITIES_LIST,
  LOAD_ACTIVITIES_REVIEWS_LIST,
  LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST,
  LOAD_SIMILAR_AREA_ACTIVITIES_LIST,
  LOAD_CAB_DETAILS,
} from "./constants";

import {
  loadActivitiesList,
  loadActivitiesListSuccess,
  loadActivitiesListError,
  loadActivitiesListRecordsMetaDataError,
  loadActivitiesListRecordsMetaDataSuccess,
  loadStateActivitiesList,
  loadStateActivitiesListSuccess,
  loadStateActivitiesListError,
  loadCityActivitiesList,
  loadCityActivitiesListSuccess,
  loadCityActivitiesListError,
  loadAreaActivitiesList,
  loadAreaActivitiesListSuccess,
  loadAreaActivitiesListError,
  loadActivityReviewsList,
  loadActivityReviewsListSuccess,
  loadActivityReviewsListError,
  loadSingleActivitiesReviewsList,
  loadSingleActivitiesReviewsListSuccess,
  loadSingleActivitiesReviewsListError,
  loadSimilarAreaPackagesList,
  loadSimilarAreaPackagesListSuccess,
  loadSimilarAreaPackagesListError,
  loadCabDetailsList,
  loadCabDetailsListSuccess,
  loadCabDetailsListError,
} from "./actions";

import {
  loadActivitiesDetails,
  loadActivitiesReviewsDetails,
  loadAreaActivitiesDetails,
  loadCabDetails,
  loadCityActivitiesDetails,
  loadRecordsMetaData,
  loadSimilarAreaPackagesDetails,
  loadSingleActivitiesReviewsDetails,
  loadStateActivitiesDetails,
} from "./remotes";

function* loadActivitiesListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ACTIVITIES_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadActivitiesList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadActivitiesDetails, destinations);

        if (result) {
          yield put(loadActivitiesListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadActivitiesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadCabDetailsListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_CAB_DETAILS),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadCabDetailsList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCabDetails, destinations);

        if (result) {
          yield put(loadCabDetailsListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadCabDetailsListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadStateActivitiesListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_STATE_ACTIVITIES_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadStateActivitiesList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadStateActivitiesDetails, destinations);

        if (result) {
          yield put(loadStateActivitiesListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadStateActivitiesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadCityActivitiesListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_CITY_ACTIVITIES_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadCityActivitiesList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCityActivitiesDetails, destinations);

        if (result) {
          yield put(loadCityActivitiesListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadCityActivitiesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadAreaActivitiesListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_AREA_ACTIVITIES_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadAreaActivitiesList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadAreaActivitiesDetails, destinations);

        if (result) {
          yield put(loadAreaActivitiesListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadAreaActivitiesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadSimilarAreaPackagesDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SIMILAR_AREA_ACTIVITIES_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadSimilarAreaPackagesList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSimilarAreaPackagesDetails, destinations);

        if (result) {
          yield put(loadSimilarAreaPackagesListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadSimilarAreaPackagesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadActivitiesReviewsListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ACTIVITIES_REVIEWS_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadActivityReviewsList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadActivitiesReviewsDetails, destinations);

        if (result) {
          yield put(loadActivityReviewsListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadActivityReviewsListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadSingleActivitiesReviewsListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadSingleActivitiesReviewsList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadSingleActivitiesReviewsDetails,
          destinations
        );

        if (result) {
          yield put(loadSingleActivitiesReviewsListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadSingleActivitiesReviewsListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadActivitiesDetailsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_ACTIVITIES_LIST_RECORDS_META_DATA),
    });

    try {
      const facilityType = yield call(
        loadRecordsMetaData,
        "facilityType/get-all-data",
        "get"
      );
      const travellerAge = yield call(
        loadRecordsMetaData,
        "travellerAge/get-all-data",
        "get"
      );
      const roomType = yield call(
        loadRecordsMetaData,
        "roomType/get-all-data",
        "get"
      );

      let recordsMetaData = {
        facilityTypeOptions:
          (facilityType &&
            facilityType &&
            facilityType.length > 0 &&
            facilityType.map((c) =>
              Object.assign(
                {},
                {
                  label: c.facilityType,
                  // shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        travellerAgeOptions:
          (travellerAge &&
            travellerAge &&
            travellerAge.length > 0 &&
            travellerAge.map((c) =>
              Object.assign(
                {},
                {
                  typeName: c.ageType,
                  count: 0,
                  age: c.age,
                  matchedId: "",
                  _id: c._id,
                }
              )
            )) ||
          [],
        roomTypeOptions:
          (roomType &&
            roomType &&
            roomType.length > 0 &&
            roomType.map((c) =>
              Object.assign(
                {},
                {
                  _id: c._id,
                  label: c.roomType,
                }
              )
            )) ||
          [],
      };

      yield put(loadActivitiesListRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadActivitiesListRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadActivitiesListSaga(),
    loadCabDetailsListSaga(),
    loadStateActivitiesListSaga(),
    loadCityActivitiesListSaga(),
    loadAreaActivitiesListSaga(),
    loadActivitiesReviewsListSaga(),
    loadSingleActivitiesReviewsListSaga(),
    loadActivitiesDetailsMetaDataSaga(),
    loadSimilarAreaPackagesDetailsSaga(),
  ]);
}
